function noto(code) {
  return `https://fonts.gstatic.com/s/e/notoemoji/latest/${code}/512.webp`;
}

export const BUILTIN_STICKERS = [
  { key: "fire", label: "אש", src: noto("1f525") },
  { key: "boom", label: "בום", src: noto("1f4a5") },
  { key: "lightning", label: "ברק", src: noto("26a1") },
  { key: "rocket", label: "טיל", src: noto("1f680") },
  { key: "arrow-right", label: "חץ ימינה", src: noto("1f449") },
  { key: "arrow-left", label: "חץ שמאלה", src: noto("1f448") },
  { key: "arrow-up", label: "חץ למעלה", src: noto("1f446") },
  { key: "arrow-down", label: "חץ למטה", src: noto("1f447") },
  { key: "sparkle", label: "ניצוצות", src: noto("2728") },
  { key: "star", label: "כוכב", src: noto("2b50") },
  { key: "glow", label: "כוכב זוהר", src: noto("1f31f") },
  { key: "heart", label: "לב", src: noto("2764_fe0f") },
  { key: "hearts", label: "לבבות", src: noto("1f496") },
  { key: "party", label: "חגיגה", src: noto("1f389") },
  { key: "confetti", label: "קונפטי", src: noto("1f38a") },
  { key: "party-face", label: "מסיבה", src: noto("1f973") },
  { key: "clap", label: "מחיאות כפיים", src: noto("1f44f") },
  { key: "hands", label: "ידיים", src: noto("1f64c") },
  { key: "muscle", label: "כוח", src: noto("1f4aa") },
  { key: "hundred", label: "100", src: noto("1f4af") },
  { key: "eyes", label: "עיניים", src: noto("1f440") },
  { key: "wow", label: "וואו", src: noto("1f92f") },
  { key: "starstruck", label: "כוכבים בעיניים", src: noto("1f929") },
  { key: "target", label: "קליעה", src: noto("1f3af") },
  { key: "trophy", label: "גביע", src: noto("1f3c6") },
  { key: "siren", label: "סירנה", src: noto("1f6a8") },
  { key: "check", label: "וי", src: noto("2705") },
  { key: "alert", label: "שים לב", src: noto("26a0_fe0f") },
];

const STICKER_MAP = Object.fromEntries(BUILTIN_STICKERS.map((item) => [item.key, item]));

export function sanitizeStickerKey(key) {
  return STICKER_MAP[key] ? key : "";
}

export function stickerSrc(key) {
  return STICKER_MAP[key]?.src || "";
}

export function StorySticker({ stickerKey, className = "pointer-events-none h-full w-full object-contain" }) {
  const src = stickerSrc(stickerKey);
  if (!src) return null;
  return <img src={src} alt="" className={className} />;
}

export function isGifBlock(block) {
  return block?.type === "gif" || !!block?.sticker_key;
}
